export default {
  editEquipmentDetails: 'Upraviť podrobnosti zariadenia',
  certificate: {
    pyrometry: 'AMS2750',
    furnaceClass: 'Trieda pece {value}',
    instrumentationType: 'Typ inštrumentácie {value}',
    heatTreatment: 'AMS2759',
  },
  capability: {
    gasChip: '{name} - {maxFlow} l/min',
  },
  capacity: {
    minTemp: 'Minimálna teplota',
    maxTemp: 'Maximálna teplota',
    dimensions: 'Rozmery',
    maxLoad: 'Maximálne zaťaženie',
    concurrentJobLimit: 'Max. počet súbežných zákaziek: {value}',
  },
  statistic: {
    targetProductivity: 'Cieľová produktivita',
  },
};
